import { render, staticRenderFns } from "./TarifaVenta.vue?vue&type=template&id=2a95a528"
import script from "./TarifaVenta.vue?vue&type=script&lang=js"
export * from "./TarifaVenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports